import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import axios from "axios";
import { Text } from "components";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useCallback, useEffect, useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
// import "./table.css";

// import Pagination from "components/Pagination";
import { pageSize } from "components/PaginationPageSize";
import Code from "components/SmallComponents/Code";
import DateTimeCell from "components/SmallComponents/DateTimeCell";
import StatusCapsule from "components/SmallComponents/StatusCapsule";
import Pagination from "pages/Pagination/Pagination";
import actionbuttonCustomStyle, {
  CustomOption,
} from "styles/actionbuttonCustomStyle.";
import { customDebounce } from "utils/helpingMethods/customDebounce";
import FinCompanyPurchaseOrderInvoiceDetails from "./FinCompanyPurchaseOrderInvoiceDetails";

import OptionalValue from "components/SmallComponents/OptionalValue";
import { FaCheck } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { BsDownload } from "react-icons/bs";
// import { pageSize } from "../../components/PaginationPageSize";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FinCompanyPurchaseOrderList = () => {
  const [copInvoiceBookingList, setcopInvoiceBookingList] = useState([]);
  const gridRef = useRef();
  const selectRef = useRef();
  const [download, setDownload] = useState(false);
  const [erplist, setErplist] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  // console.log(erplist);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 57 && item.update
  );
  const showViewColumn = erplist.some(
    (item) => item.erp_module_id == 57 && item.view
  );
  const showPageView = erplist.some(
    (item) => item.erp_module_id == 57 && item.view
  );

  //for pagination...
  const [count, setCount] = useState();
  const [recordPerPage, setRecordPerPage] = useState(pageSize);

  //for search fuctionallity...

  const [selectedOption, setSelectedOption] = useState("column");
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();

  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();

  //for cloumn
  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);
  useEffect(() => {
    getsearchCompanySpecificCriteria();
    getsetsearchcompanyspecificdaterange();
  }, []);

  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 28 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for date
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (searchCompanySpecificDateRangeId != 7 && page) {
      getcpoInvoiceBooking();
    }
  }, [
    page,
    recordPerPage,
    searchCompanySpecificCriteriaId,
    searchCompanySpecificDateRangeId,
    searchParameter,
  ]);

  useEffect(() => {
    if (
      formDate != "" &&
      toDate != "" &&
      searchParameter2 != "" &&
      searchCompanySpecificDateRangeId == 7 &&
      page
    ) {
      obj.search_parameter = searchParameter2;
      getcpoInvoiceBooking();
    }
  }, [
    page,
    // recordPerPage,
    searchParameter2,
  ]);

  //by deafult value select
  useEffect(() => {
    if (searchCompanySpecificCriteria.length > 0) {
      // Set the default selected criteria ID when the criteria list is available
      setsearchCompanySpecificCriteriaId(searchCompanySpecificCriteria[0].id);
    }
  }, [searchCompanySpecificCriteria]);

  const obj = {
    search_company_specific_criteria_id:
      searchCompanySpecificCriteriaId != undefined
        ? searchCompanySpecificCriteriaId
        : "",
    search_company_specific_date_range_id:
      searchCompanySpecificDateRangeId != undefined
        ? searchCompanySpecificDateRangeId
        : "",
    search_parameter: searchParameter,
  };
  const getcpoInvoiceBooking = () => {
    // console.log("getcpoInvoiceBooking called with obj:", obj);
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    var limit = recordPerPage;
    const requestPayload = {
      ...obj, // Include other properties from obj
      offset,
      limit,
    };
    // console.log(requestPayload);
    axios
      .post(
        "/api/purple-fusion-financial/fin-cpo-invoice/get-pagging",
        requestPayload,
        { ...headers, timeout: 20000 }
      )
      .then((response) => {
        console.log(response.data);

        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          setcopInvoiceBookingList(response.data);
          setCount(response.data[0].count);
        } else {
          setcopInvoiceBookingList([]);
          setCount(0);
        }
        setLoading(false);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching customer data:", error);
      });
  };

  const cpoInvoiceBookingList = copInvoiceBookingList
    .slice()
    .sort((a, b) => b.id - a.id);

  const DownloadPDF = () => {
    const docDefinition = {
      pageOrientation: "landscape",
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                { text: "SR.NO", style: "tableHeader" },
                { text: "GRN NO", style: "tableHeader" },
                { text: "INVOICE NUMBER", style: "tableHeader" },
                { text: "INVOICE DATE", style: "tableHeader" },
                { text: "POSTING DATE", style: "tableHeader" },
                { text: "DUE DATE", style: "tableHeader" },
                { text: "TOTAL ITEM AMT", style: "tableHeader" },
                { text: "TOTAL TAX AMT", style: "tableHeader" },
                { text: "TOTAL INVOICE AMT", style: "tableHeader" },
                { text: "TDS %", style: "tableHeader" },
                { text: "TDS AMT", style: "tableHeader" },
                { text: "RCM %", style: "tableHeader" },
                { text: "RCM AMT", style: "tableHeader" },
                { text: "STATUS ID", style: "tableHeader" },
                { text: "ACTIVE", style: "tableHeader" },
                { text: "REMARKS", style: "tableHeader" },
              ],

              ...cpoInvoiceBookingList.map((inv, index) => [
                index + 1,
                inv.grn_no,
                inv.invoice_number,
                inv.invoice_date,
                inv.posting_date,
                inv.due_date,
                inv.total_item_amount,
                inv.total_tax_amount,
                inv.total_invoice_amount,
                inv.tds_percent,
                inv.tds_amount,
                inv.rcm_percent,
                inv.rcm_amount,
                inv.fin_company_purchase_order_invoice_status_id,
                inv.is_active ? "Yes" : "No",
                inv.remarks,
              ]),
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex % 2 === 0 ? "#F5F5F5" : null;
            },
            hLineColor: () => "#CCCCCC",
            vLineColor: () => "#CCCCCC",
            paddingLeft: () => 3,
            paddingRight: () => 3,
            paddingTop: () => 3,
            paddingBottom: () => 3,
          },
        },
      ],
      styles: {
        tableHeader: {
          bold: true,
          fontSize: 5,
          fillColor: "#83B4FF",
          alignment: "center",
        },
        tableExample: {
          fontSize: 4,
        },
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download("Purchase_Order_Invoice_List.pdf");
  };

  const handleViewDetails = async (invoiceId, rowData) => {
    try {
      // open modal right away

      console.log(rowData, invoiceId);

      const res = await axios.post(
        "/api/purple-fusion-financial/fin-cpo-invoice/item/get",
        {
          fin_company_purchase_order_invoice_id: invoiceId,
        },
        {
          ...headers,
        }
      );

      console.log("items", res.data);

      setSelectedInvoice({
        ...rowData,
        items: res.data,
      });

      setDetailsModalOpen(true);
    } catch (err) {
      console.error("Failed to load invoice details:", err);
    }
  };

  const handleSubmitInvoice = async (rowData) => {
    try {
      const confirm = await Swal.fire({
        title: "Submit Invoice?",
        text: `Are you sure you want to submit invoice ${
          rowData.invoice_number || ""
        }?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Submit",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (!confirm.isConfirmed) {
        return; // User cancelled
      }

      // Call API only after confirmation
      const res = await axios.put(
        "/api/purple-fusion-financial/fin-cpo-invoice/submit-manual",
        { id: rowData.id },
        { ...headers }
      );

      if (res.data.status) {
        toast.success(res.data.message || "Invoice submitted successfully!");
        getcpoInvoiceBooking();
      } else {
        toast.error(res.data.message || "Failed to submit invoice.");
      }
    } catch (err) {
      console.error("Failed to submit invoice:", err);
      toast.error("Something went wrong while submitting.");
    }
  };

  const handleDeleteInvoice = async (rowData) => {
    try {
      const confirm = await Swal.fire({
        title: "Delete Invoice?",
        text: `Are you sure you want to delete invoice ${
          rowData.invoice_number || ""
        }? This action cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (!confirm.isConfirmed) {
        return; // User cancelled
      }

      // Call API only after confirmation
      const res = await axios.put(
        "/api/purple-fusion-financial/fin-cpo-invoice/delete-manual",
        { id: rowData.id },
        { ...headers }
      );

      if (res.data.status) {
        toast.success(res.data.message || "Invoice deleted successfully!");
        getcpoInvoiceBooking();
      } else {
        toast.error(res.data.message || "Failed to delete invoice.");
      }
    } catch (err) {
      console.error("Failed to delete invoice:", err);
      toast.error("Something went wrong while deleting.");
    }
  };

  const handleButtonClick1 = async (params) => {
    try {
      const requestData = {
        company_purchase_order_id: params.data.company_purchase_order_id,
        supplier_invoice: params.data.invoice_number,
      };
      console.log(requestData);

      const response = await axios.post(
        "/api/purple-fusion/entry/companypurchaseorderdocument/downloads",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );
      // const contentDisposition = response.headers["content-disposition"];
      const FileName = response.headers["content-disposition"];
      const contentType = response.headers["content-type"];

      // Extract file name and extension from content disposition
      // const fileNameMatch = contentDisposition.match(
      //   /filename=["']?([^'"\s]+)["']?/
      // );
      // const fileName = fileNameMatch ? fileNameMatch[1] : "download";
      // const fileExtension = fileName.split(".").pop();

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: contentType });

      // Check if the Blob type is supported before creating an Object URL
      if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
        const arrayBuffer = await blob.arrayBuffer();
        const url = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: contentType })
        );
        // Open a new tab and set its location to the Object URL
        // window.open(url);

        const a = document.createElement("a");
        a.href = url;
        // a.download = `${FileName}.${contentType.substr(0,12)}`;
        a.download = `${params.data.grn_number}.pdf`;
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        console.error(
          "Blob.arrayBuffer is not supported. Unable to create Object URL."
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.warning("Unable to download file. Please try again later.");
    }
  };

  const handleNavigation = async (option) => {
    console.log("Navigate to:", option.value);
    const params = option.params;

    switch (option.value) {
      case "View Details":
        handleViewDetails(params.data.id, params.data);
        break;

      case "Submit":
        handleSubmitInvoice(params.data);
        break;
      case "Delete":
        handleDeleteInvoice(params.data);
        break;

      case "Download":
        handleButtonClick1(params);
        break;

      // case "Edit":
      //   navigate(`/customerupdate/edit/${params.data.id}`);
      //   break;

      default:
        console.error("Unknown action:", option.value);
        break;
    }
  };

  const onBtnExport = useCallback(() => {
    const columnsToExport = [
      "supplier_name",
      "supplier_code",
      "purchase_order_code",
      "grn_no",
      "invoice_number",
      "invoice_date",
      "posting_date",
      "due_date",
      "fin_doc_type_name",
      "invoice_category_name",
      "invoice_status_name",
      "total_item_amount",
      "total_tax_amount",
      "total_invoice_amount",
      "tds_percent",
      "tds_amount",
      "rcm_percent",
      "rcm_amount",
      "remarks",
      "isactive", // keep consistent with grid
      "createdon",
    ];

    const exportColumns = customColDefs.filter((column) =>
      columnsToExport.includes(column.field)
    );

    const options = {
      fileName: "Purchase_Order_Invoice_List.csv",
      columnKeys: exportColumns.map((column) => column.field),
    };

    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const updatedActionButtonCustomStyle = {
    ...actionbuttonCustomStyle,
    control: (base) => ({
      ...base, // Spread the existing `control` styles
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
      cursor: "pointer",
      width: "120px", // Set the desired width here
      "&:hover": {
        border: "none",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: "0px", // Change the marginTop as needed
      marginRight: "100px", // Change the marginRight as needed
      marginBottom: "0", // Change the marginBottom as needed
      marginLeft: "0px", // Change the marginLeft as needed
      paddingTop: "0", // Change the paddingTop as needed
      paddingRight: "0", // Change the paddingRight as needed
      paddingBottom: "0", // Change the paddingBottom as needed
      paddingLeft: "0", // Change the paddingLeft as needed
      zIndex: 9999, // Keep the existing zIndex or modify as needed
    }),
  };

  const defaultColDefs = [
    { headerName: "Sr.No", field: "sr", width: 80 },

    // ---------------- SUPPLIER INFO ----------------
    {
      headerName: "SUPPLIER NAME",
      field: "supplier_name",
      width: 180,
      cellRenderer: (params) => <Code>{params.value}</Code>,
    },
    {
      headerName: "SUPPLIER CODE",
      field: "supplier_code",
      width: 160,
      cellRenderer: (p) => p.value || "NA",
    },

    {
      headerName: "CODE",
      field: "code",
      width: 160,
      cellRenderer: (params) => (
        <Code>
          {" "}
          <OptionalValue>{params.value}</OptionalValue>
        </Code>
      ),
    },

    // ---------------- PO & GRN DETAILS ----------------
    {
      headerName: "PO CODE",
      field: "purchase_order_code",
      width: 160,
      cellRenderer: (params) => (
        <Code>
          {" "}
          <OptionalValue>{params.value}</OptionalValue>
        </Code>
      ),
    },

    {
      headerName: "GRN NO",
      field: "grn_no",
      width: 160,
      cellRenderer: (params) => (
        <Code>
          <OptionalValue>{params.value}</OptionalValue>
        </Code>
      ),
    },
    // ---------------- INVOICE DETAILS ----------------
    {
      headerName: "INVOICE NUMBER",
      field: "invoice_number",
      // floatingFilter: true,
      width: 150,
      cellRenderer: (params) => <Code>{params.value}</Code>,
    },
    {
      headerName: "INVOICE DATE",
      field: "invoice_date",
      width: 130,
      valueFormatter: (p) => p.value?.substring(0, 10),
    },
    {
      headerName: "POSTING DATE",
      field: "posting_date",
      width: 130,
      valueFormatter: (p) => p.value?.substring(0, 10),
    },
    {
      headerName: "DUE DATE",
      field: "due_date",
      width: 130,
      valueFormatter: (p) => p.value?.substring(0, 10),
    },
    {
      headerName: "Doc Type",
      field: "fin_doc_type_name",
      width: 150,
    },

    // ---------------- CATEGORY & STATUS ----------------
    {
      headerName: "INVOICE CATEGORY",
      field: "invoice_category_name",
      width: 150,
    },
    {
      headerName: "STATUS",
      field: "invoice_status_name",
      width: 140,
      cellRenderer: (params) => (
        <>
          <StatusCapsule
            type={
              params.data.invoice_status_name === "Posted" ? "success" : "error"
            }
          >
            {params.value}
          </StatusCapsule>
        </>
      ),
    },

    // ---------------- FINANCIALS ----------------
    {
      headerName: "BASIC AMOUNTS",
      field: "total_item_amount",
      width: 140,
      valueFormatter: (p) => Number(p.value).toFixed(2),
    },
    {
      headerName: "TOTAL TAX",
      field: "total_tax_amount",
      width: 140,
      valueFormatter: (p) => Number(p.value).toFixed(2),
    },
    {
      headerName: "TOTAL AMOUNT",
      field: "total_invoice_amount",
      width: 160,
      valueFormatter: (p) => Number(p.value).toFixed(2),
    },

    {
      headerName: "TDS Code",
      field: "tds_code",
      width: 100,
    },
    {
      headerName: "TDS %",
      field: "tds_percent",
      width: 100,
    },
    {
      headerName: "TDS AMOUNT",
      field: "tds_amount",
      width: 130,
      valueFormatter: (p) => Number(p.value).toFixed(2),
    },

    {
      headerName: "RCM Code",
      field: "rcm_code",
      width: 100,
    },
    {
      headerName: "RCM %",
      field: "rcm_percent",
      width: 100,
    },
    {
      headerName: "RCM AMOUNT",
      field: "rcm_amount",
      width: 130,
      valueFormatter: (p) => Number(p.value).toFixed(2),
    },

    // ---------------- OTHERS ----------------
    {
      headerName: "REMARKS",
      field: "remarks",
      width: 150,
      cellRenderer: (p) => p.value || "NA",
    },
    {
      headerName: "ACTIVE",
      field: "isactive",
      width: 100,
      valueFormatter: (p) => (p.value ? "Yes" : "No"),
    },
    {
      headerName: "CREATED ON",
      field: "createdon",
      width: 150,
      cellRenderer: (params) => <DateTimeCell value={params.value} />,
    },

    // ---------------- ACTIONS ----------------
    {
      headerName: "ACTION",
      field: "id",
      pinned: "right",
      width: 150,
      cellRenderer: (params) => {
        const getOptions = () => {
          let options = [];
          if (showViewColumn) {
            options.push({
              value: "View Details",
              label: "View Details",
              iconColor: "rgb(59 130 246)",
              labelColor: "rgb(59 130 246)",
              icon: FaEye,
              params: params,
            });
          }
          if (params.data.invoice_status_name === "Draft" && showActionColumn) {
            options.push({
              value: "Submit",
              label: "Submit",
              iconColor: "rgb(34 197 94)", // Set the icon color
              labelColor: "rgb(34 197 94)", // Set the label color
              icon: FaCheck,
              params: params,
            });
          }
          // if (
          //   params.data.invoice_number &&
          //   params.data.company_purchase_order_id
          // ) {
          //   options.push({
          //     value: "Download",
          //     label: "Download",
          //     iconColor: "rgb(59 130 246)", // Set the icon color
          //     labelColor: "rgb(59 130 246)", // Set the label color
          //     icon: BsDownload,
          //     params: params,
          //   });
          // }
          if (params.data.invoice_status_name === "Draft" && showActionColumn) {
            options.push({
              value: "Delete",
              label: "Delete",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(239 68 68)", // Set the label color
              icon: RiDeleteBin6Line,
              params: params,
            });
          }

          return options;
        };

        return (
          <div style={{ width: "100%", position: "relative", zIndex: 999 }}>
            <Select
              options={getOptions()}
              isSearchable={false}
              onChange={handleNavigation}
              placeholder={"ACTION"}
              menuPlacement="bottom"
              menuPortalTarget={selectRef.current}
              styles={updatedActionButtonCustomStyle}
              value={null}
              components={{ Option: CustomOption }}
            />
          </div>
        );
      },
    },
  ];

  const customColDefs = [
    ...defaultColDefs,
    // {
    //   headerName: "",
    //   field: "id",
    //   // pinned: "right",
    //   cellRenderer: (params) => (
    //     <div className="mt-2">
    //       <button
    //         className="font-small text-blue-600 dark:text-blue-500 mr-2 "
    //         onClick={() => {
    //           navigate(`/customerupdate/edit/${params.value}`);
    //         }}
    //       >
    //         <FaRegEdit />
    //       </button>
    //     </div>
    //   ),
    //   width: 50,
    //   filter: false,
    // },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(
      showActionColumn
        ? showViewColumn
          ? customColDefs
          : customColDefs.filter((col) => col.headerName !== "ACTIONS")
        : showViewColumn
        ? defaultColDefs
        : defaultColDefs.filter((col) => col.headerName !== "ACTIONS")
    );
  }, [showActionColumn, showViewColumn]);

  const ColDefaultVale = { filter: true, floatingFilter: false };

  //for option change...
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };
  const fieldToSearchIdMap = {
    name: 2497, // "Customer Name"
    business_type_name: 2498, // "Customer Business Type"
    mobilenumber: 2499, // "Mobile Number"
    emailid: 2500, // "Email Address"
  };

  const handleFilterChange = () => {
    const allFilters = gridRef.current.api.getFilterModel();
    const field = Object.keys(allFilters)[0];
    const value = allFilters[field]?.filter;

    console.log("Field:", field + ", Value:", value);

    const searchId = fieldToSearchIdMap[field];

    // ✅ If no filter value or filter was cleared, fetch full data
    if (!value) {
      console.log("Fetching unfiltered data");

      getcpoInvoiceBooking(); // Call your existing unfiltered fetch function
      return;
    }

    if (!searchId) return;

    const obj = {
      search_company_specific_criteria_id: searchId,
      search_company_specific_date_range_id: "",
      search_parameter: value,
    };

    const offset = (page - 1) * recordPerPage;
    const limit = recordPerPage;

    const requestPayload = {
      ...obj,
      offset,
      limit,
    };
    console.log("Request Payload for Filtered Data:", requestPayload);

    axios
      .post(
        "/api/purple-fusion/customer/get/forpagginationandsearching",
        requestPayload,
        {
          ...headers,
          timeout: 20000,
        }
      )
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          setcopInvoiceBookingList(response.data);
          setCount(response.data[0].count);
        } else {
          setcopInvoiceBookingList([]);
          setCount(0);
        }
        setLoading(false);
        console.log("Filtered data:", response.data);
      })
      .catch((error) => {
        console.error("Error fetching filtered data:", error);
      });
  };

  return (
    <>
      {showPageView ? (
        <>
          <div className="flex p-2 flex-row w-full items-center">
            <Text
              className="text-base md:text-[22px]  text-gray-800 sm:text-xl tracking-[0.20px] w-full"
              size="txtInterSemiBold24"
            >
              Purchase Invoice
            </Text>
            <Text
              className="text-sm md:text-[22px] whitespace-nowrap text-gray-600 sm:text-xl tracking-[0.20px] mr-1"
              size="txtInterSemiBold24"
            >
              {" "}
              Search By :
            </Text>

            <div className="flex gap-2 items-center justify-center">
              <input
                type="radio"
                id="column"
                name="option"
                checked={selectedOption === "column"}
                onChange={(event) => {
                  handleOptionChange(event);
                  setsearchCompanySpecificDateRangeId("");
                  setsearchParameter("");
                  setPage(1);
                }}
                className="scale-100"
              />
              <label className=" text-gray-600  text-sm"> Column</label>

              <input
                type="radio"
                className="scale-100 "
                id="date"
                name="option"
                checked={selectedOption === "date"}
                onChange={(event) => {
                  handleOptionChange(event);
                  setsearchCompanySpecificCriteriaId("");
                  setsearchParameter("");
                  setPage(1);
                }}
              />
              <label className=" text-gray-600 text-sm"> Date</label>

              {selectedOption == "column" && (
                <Select
                  options={searchCompanySpecificCriteria.map((resstate) => ({
                    label: resstate.criteria,
                    value: resstate.id,
                  }))}
                  className="bg-white-A700 border border-gray-200_02"
                  onChange={(selectedoption) => {
                    setsearchCompanySpecificCriteriaId(selectedoption.value);
                    setPage(1);
                  }}
                  defaultValue={
                    searchCompanySpecificCriteria.length > 0
                      ? {
                          label: searchCompanySpecificCriteria[0].criteria,
                          value: searchCompanySpecificCriteria[0].id,
                        }
                      : {
                          label: "Supplier Name", // Set default label when there are no criteria
                          value: null, // Set value to null or a default id if necessary
                        }
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "30px", // Adjust the height as needed
                      width: "140px", // Adjust the width as needed
                      display: "flex",
                      alignItems: "center", // Center vertically
                      justifyContent: "center", // Center horizontally
                    }),
                  }}
                />
              )}

              {selectedOption == "date" && (
                <Select
                  options={searchcompanyspecificdaterange.map((resstate) => ({
                    label: resstate.date_range,
                    value: resstate.search_date_range_id,
                  }))}
                  className="bg-white-A700 border border-gray-200_02 "
                  onChange={(selectedoption) => {
                    setsearchCompanySpecificDateRangeId(selectedoption.value);
                    setPage(1);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "30px", // Adjust the height as needed
                      width: "140px", // Adjust the width as needed
                      display: "flex",
                      alignItems: "center", // Center vertically
                      justifyContent: "center", // Center horizontally
                    }),
                  }}
                />
              )}

              {selectedOption == "column" && (
                <input
                  name="searchParamater"
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => {
                    setsearchParameter(e.target.value);
                    setPage(1);
                  }}
                  className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-40"
                ></input>
              )}

              {selectedOption == "date" &&
                searchCompanySpecificDateRangeId === 7 && (
                  <div className="flex flex-row">
                    <input
                      name="from_date"
                      type="date"
                      onChange={(e) => {
                        setFormDate(e.target.value);
                        setsearchParameter2(
                          e.target.value.concat("@" + toDate)
                        );
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%] text-base"
                    />
                    <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl p-1 pt-2  ">
                      To
                    </Text>

                    <input
                      name="to_date"
                      type="date"
                      onChange={(e) => {
                        setToDate(e.target.value);
                        setsearchParameter2(
                          formDate.concat("@" + e.target.value)
                        );
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%] text-base"
                    />
                  </div>
                )}
            </div>
            <ToastContainer />
            <div className="flex text-3xl relative flex-row justify-end items-center font-inter gap-2  w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white-A700">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 h-9 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-2 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    className="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20  divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    className="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={DownloadPDF}
                      >
                        PDF
                      </span>
                    </li>
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={onBtnExport}
                      >
                        Excel
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {erplist.some((item) => item.erp_module_id === 7 && item.add) && (
                <div className="flex flex-col items-center  justify-center">
                  <button
                    type="button"
                    id="dropdownDefaultButton"
                    onClick={() => navigate("/purchase-invoice-booking/add")}
                    className="text-white-A700 bg-blue-700 h-9  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                  >
                    + Add
                  </button>
                </div>
              )}
            </div>
          </div>

          <div
            className="ag-theme-quartz"
            id="my-table1"
            ref={selectRef}
            // style={customeStyle}
          >
            <AgGridReact
              ref={gridRef}
              rowData={cpoInvoiceBookingList.map(
                (copInvoiceBookingList, index) => ({
                  ...copInvoiceBookingList,
                  sr: index + (offsetforSR + 1),
                })
              )}
              columnDefs={colDefs}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
              onFilterChanged={customDebounce(handleFilterChange, 500)}
            />
          </div>

          <div>
            <Pagination
              count={count}
              setRecordPerPage={setRecordPerPage}
              recordPerPage={recordPerPage}
              setLoading={setLoading}
              setData={setcopInvoiceBookingList}
              setPage={setPage}
              page={page}
            />
          </div>
          {detailsModalOpen && (
            <FinCompanyPurchaseOrderInvoiceDetails
              open={detailsModalOpen}
              onClose={() => setDetailsModalOpen(false)}
              data={selectedInvoice}
            />
          )}
        </>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
};

export default FinCompanyPurchaseOrderList;
